<template>
  <StockValuationReport :withCost="true"/>
</template>

<script>
  import HTTPRequest from '../../controllers/httpRequest.js';
  import StockValuationReport from '../Basic Sales Reports/StockValuationReport';
  import { mapState } from 'vuex';

  export default {
    components: { StockValuationReport },
    computed: {
      ...mapState(['endPoint']),
    },
    beforeMount: async function() {
      // Check if user has permission for Basic Inventory Reports (R-002) Stock Valuation Report With Cost (BI-009)
      const userActiveModulesURL = `${this.endPoint}system_module_categories/user_enabled_modules?module_codes=BI-009&category_codes=R-002`;
      const userActiveModules = await HTTPRequest.getRequest(userActiveModulesURL, null, null);
      if (userActiveModules.enabled_modules.length == 0) {
        this.$router.push('dashboard');
        return;
      }
    },
  };
</script>

<style></style>
